import { render, staticRenderFns } from "./member.vue?vue&type=template&id=65f27815&scoped=true"
import script from "./member.vue?vue&type=script&lang=js"
export * from "./member.vue?vue&type=script&lang=js"
import style0 from "./member.vue?vue&type=style&index=0&id=65f27815&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f27815",
  null
  
)

export default component.exports